<template>
  <div>
    <div
      class="Kanit primary pa-4 text-center white--text"
      style="font-size: 22px"
    >
      ลงทะเบียน
    </div>
    <div>
      <v-btn @click="$emit('prevstep')" text color="primary">
        <v-icon>mdi-chevron-left</v-icon>
        กลับ
      </v-btn>
    </div>
    <ValidationObserver ref="observer">
      <div class="pa-5">
        <div style="font-size: 19px">กรอกข้อมูลห้างและสาขา</div>
        <div class="mt-4">ห้าง</div>
        <div>
          <ValidationProvider
            :rules="{
              required: true,
            }"
            name="ห้าง"
            v-slot="{ errors }"
          >
            <v-autocomplete
              v-model="input.departmentStore"
              dense
              :error-messages="errors"
              @change="onChangeDepartment"
              :items="departmentOptions"
              outlined
              placeholder="เลือกห้าง"
            ></v-autocomplete>
          </ValidationProvider>
        </div>
        <div class="mt-4">สาขา</div>
        <div>
          <ValidationProvider
            :rules="{
              required: true,
            }"
            name="ห้าง"
            v-slot="{ errors }"
          >
            <v-autocomplete
              :disabled="$store.state.branchloading"
              :loading="$store.state.branchloading"
              :error-messages="errors"
              :no-data-text="'กรุณาเลือกห้างก่อนเลือกสาขา'"
              :items="optionsBranch"
              v-model="input.branch"
              dense
              outlined
              placeholder="เลือกสาขา"
            ></v-autocomplete>
          </ValidationProvider>
        </div>
        <div class="mt-4">
          <v-btn
            @click="next"
            style="font-size: 22px"
            class="text-capitalize"
            color="primary"
            dark
            block
            >ถัดไป</v-btn
          >
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
export default {
  computed: {
    input() {
      return this.$store.state.input;
    },
    departmentOptions() {
      var departments = [
        ...new Set(this.$store.state.branch.map((el) => el.department_store)),
      ];
      return departments;
    },
    // branchOptions() {
    //   if (this.input.departmentStore) {
    //     var departments = this.$store.state.branch
    //       .filter((el) => el.department_store == this.input.departmentStore)
    //       .map((el) => el.branch);

    //     return departments;
    //   } else return [];
    // },
  },
  data() {
    return {
      // optionsDepartmentStore: ["departmentStore"],
      optionsBranch: [],
    };
  },
  mounted() {
    var departmentStore = this.query.departmentStore;
    var branch = this.query.branch;

    if (departmentStore) {
      this.onChangeDepartment(departmentStore);
      this.input.departmentStore = departmentStore;
    }
    
    if(branch) {
      this.input.branch = branch;
    }
  },
  methods: {
    async next() {
      if (await this.$refs.observer.validate()) {
        this.$emit("nextstep");
      }
    },
    async onChangeDepartment(payload) {
      this.input.branch = "";
      this.$refs.observer.reset();
      this.$forceUpdate();
      var data = await this.$store.dispatch("getSubBranch", payload);
      this.optionsBranch = data;
    },
  },
};
</script>